import React, { useEffect, useState, useRef } from 'react';
import api from '../../api';

function AdminGallery() {
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const fileRef = useRef();

  const load = () => api.get('/gallery/admin').then(r => setImages(r.data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append('image', file);
    fd.append('title', title || 'Sin título');
    fd.append('description', description);
    try {
      await api.post('/gallery', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setTitle('');
      setDescription('');
      fileRef.current.value = '';
      load();
    } catch (err) {
      alert('Error al subir imagen');
    }
    setUploading(false);
  };

  const toggleActive = async (img) => {
    await api.put(`/gallery/${img.id}`, { active: img.active ? 0 : 1 });
    load();
  };

  const deleteImage = async (id) => {
    if (!window.confirm('¿Eliminar esta imagen?')) return;
    await api.delete(`/gallery/${id}`);
    load();
  };

  return (
    <>
      <div className="admin-topbar"><h1>Gestión de Galería</h1></div>
      <div className="admin-content">
        <div className="admin-card">
          <h3>Subir nueva foto</h3>
          <form onSubmit={handleUpload}>
            <div className="upload-zone" onClick={() => fileRef.current?.click()}>
              <span className="material-icons">cloud_upload</span>
              <p>Haz clic aquí para seleccionar una imagen</p>
              <p style={{ fontSize: '0.8rem', color: 'var(--text-lighter)' }}>JPEG, PNG, WEBP (máx. 10MB)</p>
              <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" style={{ display: 'none' }} />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Título</label>
                <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Ej: Instalaciones del colegio" />
              </div>
              <div className="form-group">
                <label>Descripción (opcional)</label>
                <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Breve descripción" />
              </div>
            </div>
            <button type="submit" className="btn-save" disabled={uploading}>
              <span className="material-icons" style={{ fontSize: '1rem' }}>upload</span>
              {uploading ? 'Subiendo...' : 'Subir imagen'}
            </button>
          </form>
        </div>

        <div className="admin-card">
          <h3>Fotos ({images.length})</h3>
          {images.length === 0 ? (
            <p style={{ color: 'var(--text-light)', padding: '2rem', textAlign: 'center' }}>No hay fotos aún. Sube la primera.</p>
          ) : (
            <div className="gallery-admin-grid">
              {images.map(img => (
                <div key={img.id} className="gallery-admin-item" style={{ opacity: img.active ? 1 : 0.5 }}>
                  <img src={`/api/uploads/gallery/thumb_${img.filename}`} alt={img.title} />
                  <div className="info">
                    <h4>{img.title}</h4>
                    <p>{img.active ? 'Visible' : 'Oculta'}</p>
                  </div>
                  <div className="actions">
                    <button onClick={() => toggleActive(img)}>
                      {img.active ? 'Ocultar' : 'Mostrar'}
                    </button>
                    <button className="delete-btn" onClick={() => deleteImage(img.id)}>
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AdminGallery;
